import React from "react";
import moment from "moment";
import EditIcon from "../../assets/editIcon.png";
import DeleteIcon from "../../assets/deleteIcon.png";

function StaffListWeb({staffList, staffEdit, staffDelete, currentPage}) {
  return (
    <>
      <div className="d-flex staff-heading-web py-3 mt-2 mr-1">
        <div className="col-lg-1">NO.</div>
        <div className="col-lg-3">STAFF NAME</div>
        <div className="col-lg-3">PHONE NUMBER</div>
        <div className="col-lg-3">ADDED ON</div>
        <div className="col-lg-2">ACTION</div>
      </div>
      {staffList.map((details, indx) => (
        <div className="d-flex staff-list-web py-3 mr-1" key={indx}>
          <div className="col-lg-1">{(currentPage - 1) * 10 + indx + 1}</div>
          <div className="col-lg-3">
            {details?.first_name} {details?.middle_name} {details?.last_name}
          </div>
          <div className="col-lg-3">{details.phone_no}</div>
          <div className="col-lg-3">
            {moment(details.created_at).format("MMM DD, YYYY")} at{" "}
            {moment(details.created_at).format("hh:mm A")}
          </div>
          <div className="col-lg-2">
            <img
              src={EditIcon}
              className="mr-3"
              alt="edit"
              style={{cursor: "pointer"}}
              onClick={() => staffEdit(details.staff_id)}
            />
            <img
              src={DeleteIcon}
              alt="delete"
              style={{cursor: "pointer"}}
              onClick={() =>
                staffDelete(
                  details.staff_id,
                  details.first_name,
                  details.last_name
                )
              }
            />
          </div>
        </div>
      ))}
    </>
  );
}

export default StaffListWeb;
